import { type FC } from 'react'
import pluralize from 'pluralize'
import { Link } from 'react-router-dom'
import { FormFeedback } from '../../../components/Form/FormFeedback'
import { RoleType } from '../../../models/Role'
import { type SeatPurchase } from '../../../store/auth/auth'
import { seatTypeLabels } from '../roleChangeSeatImpact'
import { SeatPurchaseSummary } from '../SeatPurchaseSummary'
import { type SeatPurchasePreview } from '../useSeatPurchasePreview'

export interface BulkInvitePurchaseStepProps {
  purchase: SeatPurchase
  invitationCount: number
  preview: SeatPurchasePreview
  error: string | null
}

const seatPhrase = (count: number, seatType: RoleType) => `${count} ${seatTypeLabels[seatType]} ${pluralize('seat', count)}`

const purchasePhrase = (purchase: SeatPurchase) =>
  [purchase.general > 0 ? seatPhrase(purchase.general, RoleType.SEAT) : null, purchase.sidecar > 0 ? seatPhrase(purchase.sidecar, RoleType.SIDECAR) : null]
    .filter(Boolean)
    .join(' and ')

export const BulkInvitePurchaseStep: FC<BulkInvitePurchaseStepProps> = ({ purchase, invitationCount, preview, error }) => (
  <div className='d-flex flex-column gap-3'>
    <div className='paragraph-medium'>
      You&apos;re about to buy {purchasePhrase(purchase)} for {invitationCount} requested {pluralize('invitation', invitationCount)}.
      <br />
      {invitationCount === 1
        ? "Once you confirm, we'll send their invitation. Not ready? Cancel and the user stays in the requested list."
        : "Once you confirm, we'll send the invitations. Not ready? Cancel and the users stay in the requested list."}
    </div>
    <SeatPurchaseSummary preview={preview} />
    <div className='paragraph-small zocks-text-gray-600'>
      You can also manage your seats on the{' '}
      <Link to='/account/plan' className='zocks-text-primary'>
        Plan page
      </Link>
      .
    </div>
    {error ? <FormFeedback>{error}</FormFeedback> : null}
  </div>
)
